import { Box, Grid, Typography } from '@mui/material';
import { formatterPTY } from '../../../../utils/utils';

const DataGridTotalFooterColocacion = (props) => {
    return (
        <Box display={'flex'} padding={2}>
            <Grid container spacing={2}>
                <Grid item xs={props.totalSize} textAlign={'start'}>
                    <Typography variant="subtitle2" fontWeight="bold">
                        Total
                    </Typography>
                </Grid>
                <Grid
                    item
                    xs={
                        props.tipoCampaña
                            ? props.isFundraising
                                ? 0.6
                                : 1.26
                            : props.isFundraising
                            ? 0.6
                            : 1.26
                    }
                    textAlign={'center'}
                >
                    <Typography variant="subtitle2" fontWeight="bold">
                        {props.lunes.cantidad}
                    </Typography>
                </Grid>
                {props.isFundraising && (
                    <Grid
                        item
                        xs={props.isCampaña ? 0.75 : 0.72}
                        textAlign={'center'}
                    >
                        <Typography variant="subtitle2" fontWeight="bold">
                            {formatterPTY.format(props.lunes.donacion)}
                        </Typography>
                    </Grid>
                )}
                <Grid
                    item
                    xs={
                        props.tipoCampaña
                            ? props.isFundraising
                                ? 0.63
                                : 1.23
                            : props.isFundraising
                            ? 0.63
                            : 1.23
                    }
                    textAlign={'center'}
                >
                    <Typography variant="subtitle2" fontWeight="bold">
                        {props.martes.cantidad}
                    </Typography>
                </Grid>
                {props.isFundraising && (
                    <Grid
                        item
                        xs={props.tipoCampaña ? 0.75 : 0.65}
                        textAlign={'center'}
                    >
                        <Typography variant="subtitle2" fontWeight="bold">
                            {formatterPTY.format(props.martes.donacion)}
                        </Typography>
                    </Grid>
                )}
                <Grid
                    item
                    xs={
                        props.tipoCampaña
                            ? props.isFundraising
                                ? 0.63
                                : 1.26
                            : props.isFundraising
                            ? 0.7
                            : 1.26
                    }
                    textAlign={'center'}
                >
                    <Typography variant="subtitle2" fontWeight="bold">
                        {props.miercoles.cantidad}
                    </Typography>
                </Grid>
                {props.isFundraising && (
                    <Grid
                        item
                        xs={props.tipoCampaña ? 0.75 : 0.65}
                        textAlign={'center'}
                    >
                        <Typography variant="subtitle2" fontWeight="bold">
                            {formatterPTY.format(props.miercoles.donacion)}
                        </Typography>
                    </Grid>
                )}
                <Grid
                    item
                    xs={
                        props.tipoCampaña
                            ? props.isFundraising
                                ? 0.63
                                : 1.28
                            : props.isFundraising
                            ? 0.65
                            : 1.28
                    }
                    textAlign={'center'}
                >
                    <Typography variant="subtitle2" fontWeight="bold">
                        {props.jueves.cantidad}
                    </Typography>
                </Grid>
                {props.isFundraising && (
                    <Grid
                        item
                        xs={props.tipoCampaña ? 0.75 : 0.68}
                        textAlign={'center'}
                    >
                        <Typography variant="subtitle2" fontWeight="bold">
                            {formatterPTY.format(props.jueves.donacion)}
                        </Typography>
                    </Grid>
                )}
                <Grid
                    item
                    xs={
                        props.tipoCampaña
                            ? props.isFundraising
                                ? 0.63
                                : 1.26
                            : props.isFundraising
                            ? 0.68
                            : 1.26
                    }
                    textAlign={'center'}
                >
                    <Typography variant="subtitle2" fontWeight="bold">
                        {props.viernes.cantidad}
                    </Typography>
                </Grid>
                {props.isFundraising && (
                    <Grid
                        item
                        xs={props.tipoCampaña ? 0.75 : 0.65}
                        textAlign={'center'}
                    >
                        <Typography variant="subtitle2" fontWeight="bold">
                            {formatterPTY.format(props.viernes.donacion)}
                        </Typography>
                    </Grid>
                )}
                <Grid
                    item
                    xs={
                        props.tipoCampaña
                            ? props.isFundraising
                                ? 0.63
                                : 1.26
                            : props.isFundraising
                            ? 0.66
                            : 1.26
                    }
                    textAlign={'center'}
                >
                    <Typography variant="subtitle2" fontWeight="bold">
                        {props.sabado.cantidad}
                    </Typography>
                </Grid>
                {props.isFundraising && (
                    <Grid
                        item
                        xs={props.tipoCampaña ? 0.75 : 0.68}
                        textAlign={'center'}
                    >
                        <Typography variant="subtitle2" fontWeight="bold">
                            {formatterPTY.format(props.sabado.donacion)}
                        </Typography>
                    </Grid>
                )}
                <Grid
                    item
                    xs={
                        props.tipoCampaña
                            ? props.isFundraising
                                ? 0.63
                                : 1.25
                            : props.isFundraising
                            ? 0.63
                            : 1.25
                    }
                    textAlign={'center'}
                >
                    <Typography variant="subtitle2" fontWeight="bold">
                        {props.domingo.cantidad}
                    </Typography>
                </Grid>
                {props.isFundraising && (
                    <Grid item xs={0.75} textAlign={'center'}>
                        <Typography variant="subtitle2" fontWeight="bold">
                            {formatterPTY.format(props.domingo.donacion)}
                        </Typography>
                    </Grid>
                )}
                <Grid
                    item
                    xs={
                        props.tipoCampaña
                            ? props.isFundraising
                                ? 0.65
                                : 0.75
                            : props.isFundraising
                            ? 0.58
                            : 0.75
                    }
                    textAlign={props.isFundraising ? 'center' : 'end'}
                >
                    <Typography variant="subtitle2" fontWeight="bold">
                        {props.total_semana.cantidad}
                    </Typography>
                </Grid>
                {props.isFundraising && (
                    <Grid
                        item
                        xs={
                            props.tipoCampaña
                                ? props.isFundraising
                                    ? 0.63
                                    : 0.75
                                : props.isFundraising
                                ? 0.64
                                : 0.75
                        }
                        textAlign={'end'}
                    >
                        <Typography variant="subtitle2" fontWeight="bold">
                            {formatterPTY.format(props.total_semana.donacion)}
                        </Typography>
                    </Grid>
                )}
            </Grid>
        </Box>
    );
};

export default DataGridTotalFooterColocacion;
